import { getAccountsMessageMembersFilter, getAccountsViewFilterNew } from '@juvare/contact-management/backend/features/permissions/shared';
import { userCanMessageNonMembers } from './shared';
/**
 * Constructs base filter that should be always applied when listing accounts to be notified.
 * IMPORTANT make sure this filter is always applied whenever you are listing accounts in Alerts.
 *
 * @param userState
 * @param includeNonMembers - when true will return wider filter that includes users that are not yet members. If user cannot list non-members regular 'message members' filter will be used;
 */
export function getMessageAccountsBaseFilter(userState, includeNonMembers) {
    let filter;
    if (userCanMessageNonMembers(userState)) {
        filter = includeNonMembers ? getAccountsViewFilterNew(userState) : getAccountsMessageMembersFilter(userState);
    }
    else {
        filter = getAccountsMessageMembersFilter(userState);
    }
    filter = filter.filter((f) => !('column' in f && f.column === 'systemStatus'));
    filter.push({ column: 'systemStatus', op: '=', value: 'active' });
    return filter;
}
